import { FC } from 'react';
import { DatePicker as AntDatePicker, DatePickerProps as AntDatePickerProps } from 'antd';
import dayjs from 'dayjs';
import styled from 'styled-components';

type DatePickerProps = Omit<AntDatePickerProps, 'value' | 'onChange'> & {
  value?: string | null;
  onChange?: (date: string) => void;
};

export const DatePicker: FC<DatePickerProps> = ({ value, onChange, ...props }) => (
  <StyledDatePicker
    format={'DD MMMM YYYY'}
    {...props}
    value={value ? dayjs(value) : undefined}
    onChange={(date) => {
      onChange?.(date ? date.toISOString() : date);
    }}
  />
);

const StyledDatePicker = styled(AntDatePicker)`
  &&& {
    width: 100%;
    height: 40px;

    input::placeholder {
      color: #c8cacc;
    }

    .ant-picker-input {
      cursor: pointer;
    }
  }
`;
